import React, { memo } from 'react';

import { usePersonalAccountFields } from '@shared/hooks/usePersonalAccountFields';
import { FieldLabels } from '@shared/types/enums/fieldLabels.enum';
import { Input } from '@shared/ui/Input';
import { VStack } from '@shared/ui/Stack';

import clsMain from '../Form/Form.module.scss';
import cls from './Contacts.module.scss';

type ContactsProps = Pick<
  ReturnType<typeof usePersonalAccountFields>,
  | 'email'
  | 'errorEmail'
  | 'handleChangeEmail'
  | 'phoneNumber'
  | 'handleChangePhoneNumber'
  | 'lastName'
  | 'errorLastName'
  | 'handleChangeLastName'
  | 'firstName'
  | 'errorFirstName'
  | 'handleChangeFirstName'
  | 'secondName'
  | 'handleChangeSecondName'
>;

export const Contacts = memo<ContactsProps>(
  ({
    email,
    errorEmail,
    handleChangeEmail,
    phoneNumber,
    handleChangePhoneNumber,
    lastName,
    errorLastName,
    handleChangeLastName,
    firstName,
    errorFirstName,
    handleChangeFirstName,
    secondName,
    handleChangeSecondName
  }) => {
    return (
      <div className={clsMain.plate}>
        <h2 className={clsMain.title}>Контактные данные</h2>
        <VStack className={cls.plateInputWrapper}>
          <div className={cls.inputsLine}>
            <div className={cls.phoneWrapper}>
              <Input
                fullWidth
                label={FieldLabels.EMAIL}
                value={email || ''}
                required
                isError={errorEmail}
                onChange={handleChangeEmail}
              />
            </div>
            <div className={cls.emailWrapper}>
              <Input
                fullWidth
                label={FieldLabels.PHONE_NUMBER}
                value={phoneNumber || ''}
                disabled
                required
                phoneMask
                onChange={handleChangePhoneNumber}
              />
            </div>
          </div>
          <div className={cls.inputsLine}>
            <Input
              label={FieldLabels.LAST_NAME}
              value={lastName || ''}
              required
              isError={errorLastName}
              onChange={handleChangeLastName}
            />
            <Input
              label={FieldLabels.FIRST_NAME}
              value={firstName || ''}
              required
              isError={errorFirstName}
              onChange={handleChangeFirstName}
            />
          </div>
          <Input
            fullWidth
            label={FieldLabels.SECOND_NAME}
            value={secondName || ''}
            onChange={handleChangeSecondName}
          />
        </VStack>
      </div>
    );
  }
);
